(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-conditional-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('variant-conditional-content')) {
    customElements.define(
      'variant-conditional-content',
      class VariantConditionalContent extends HTMLElement {
        connectedCallback() {
          this.updateVisibility = this.updateVisibility.bind(this);

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
          } else {
            this.initialize();
          }
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        initialize() {
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.updateVisibility);
          }

          const variantId = new URL(window.location.href).searchParams.get('variant');
          if (variantId) this.setVisibility(variantId);
        }

        updateVisibility(event) {
          this.setVisibility(event?.data?.variant?.id);
        }

        setVisibility(variantId) {
          const shouldShow = String(variantId) === this.dataset.targetVariantId;
          this.hidden = !shouldShow;

          if (shouldShow) {
            requestAnimationFrame(() => {
              this.querySelectorAll('variant-feature-marquee').forEach((marquee) => marquee.refresh());
            });
          }
        }
      }
    );
  }

  if (!customElements.get('variant-feature-marquee')) {
    customElements.define(
      'variant-feature-marquee',
      class VariantFeatureMarquee extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('.variant-feature-marquee__viewport');
          this.track = this.querySelector('.variant-feature-marquee__track');
          this.content = this.querySelector('.variant-feature-marquee__content');
          this.speed = Number(this.dataset.speed) || 50;
          this.position = 0;
          this.contentWidth = 0;
          this.animationFrame = null;
          this.lastTimestamp = null;

          if (!this.viewport || !this.track || !this.content) return;

          this.handleClick = this.handleClick.bind(this);
          this.setup = this.setup.bind(this);
          this.start = this.start.bind(this);
          this.pause = this.pause.bind(this);
          this.resizeObserver = new ResizeObserver(this.setup);

          this.addEventListener('click', this.handleClick);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.content);

          if (this.dataset.pauseOnHover === 'true') {
            this.addEventListener('mouseenter', this.pause);
            this.addEventListener('mouseleave', this.start);
          }

          requestAnimationFrame(() => {
            this.setup();
            this.start();
          });

          document.fonts?.ready.then(this.setup);
        }

        disconnectedCallback() {
          this.pause();
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('mouseenter', this.pause);
          this.removeEventListener('mouseleave', this.start);
          this.resizeObserver?.disconnect();
        }

        handleClick(event) {
          const item = event.target.closest('.variant-feature-marquee__item[data-link]');
          if (item) window.location.href = item.dataset.link;
        }

        setup() {
          this.track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());
          this.contentWidth = this.content.getBoundingClientRect().width;
          if (this.contentWidth <= 0) return;

          const requiredWidth = this.viewport.clientWidth + this.contentWidth;

          do {
            const clone = this.content.cloneNode(true);
            clone.dataset.marqueeClone = '';
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
              element.removeAttribute('data-shopify-editor-block');
            });
            this.track.appendChild(clone);
          } while (this.track.scrollWidth < requiredWidth);

          this.position %= this.contentWidth;
          this.track.style.transform = `translate3d(${this.position}px, 0, 0)`;
          this.start();
        }

        refresh() {
          this.setup();
        }

        start() {
          if (this.animationFrame || this.contentWidth <= 0) return;
          this.lastTimestamp = null;

          const animate = (timestamp) => {
            if (this.lastTimestamp !== null) {
              const elapsed = Math.min((timestamp - this.lastTimestamp) / 1000, 0.1);
              this.position -= this.speed * elapsed;

              if (Math.abs(this.position) >= this.contentWidth) {
                this.position += this.contentWidth;
              }

              this.track.style.transform = `translate3d(${this.position}px, 0, 0)`;
            }

            this.lastTimestamp = timestamp;
            this.animationFrame = requestAnimationFrame(animate);
          };

          this.animationFrame = requestAnimationFrame(animate);
        }

        pause() {
          if (!this.animationFrame) return;
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
          this.lastTimestamp = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-overlay-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('viewport-video')) {
    customElements.define(
      'viewport-video',
      class ViewportVideo extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true') return;

          if (!('IntersectionObserver' in window)) {
            this.load();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.load();
              }
            },
            {
              rootMargin: '300px 0px'
            }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        load() {
          if (this.dataset.loaded === 'true') return;

          const template = this.querySelector('template');

          if (!template) return;

          this.dataset.loaded = 'true';

          const content = template.content.cloneNode(true);

          content.querySelectorAll('wistia-player').forEach((player) => {
            player.setAttribute('autoplay', '');
            player.setAttribute('muted', '');
          });

          content.querySelectorAll('video').forEach((video) => {
            video.autoplay = true;
            video.muted = true;
            video.playsInline = true;
          });

          content.querySelectorAll('script').forEach((script) => {
            const activeScript = document.createElement('script');

            Array.from(script.attributes).forEach((attribute) => {
              activeScript.setAttribute(
                attribute.name,
                attribute.value
              );
            });

            activeScript.textContent = script.textContent;
            script.replaceWith(activeScript);
          });

          this.appendChild(content);
          template.remove();
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('viewport-video')) {
    customElements.define(
      'viewport-video',
      class ViewportVideo extends HTMLElement {
        connectedCallback() {
          if (!('IntersectionObserver' in window)) {
            this.load();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.load();
              }
            },
            { rootMargin: '300px 0px' }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        load() {
          const template = this.querySelector('template');

          if (!template) return;

          const content = template.content.cloneNode(true);

          content.querySelectorAll('wistia-player').forEach((player) => {
            player.setAttribute('autoplay', '');
            player.setAttribute('muted', '');
          });

          content.querySelectorAll('script').forEach((script) => {
            const activeScript = document.createElement('script');

            Array.from(script.attributes).forEach((attribute) => {
              activeScript.setAttribute(attribute.name, attribute.value);
            });

            activeScript.textContent = script.textContent;
            script.replaceWith(activeScript);
          });

          this.appendChild(content);
          template.remove();
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
